// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SPnq3","badges":"styles_badges__qRbLT"};